export default __webpack_public_path__ + "static/media/5.ed0300d2.png";